export const faqData = {
  title: 'Perguntas frequentes',
  features: [
    {
      title: 'O que é preciso para utilizar API Qive?',
      description: (
        <>
          Para utilizar API Qive é necessário realizar a integração de acordo
          com a nossa documentação, que pode ser consultada{' '}
          <a href="https://developers.arquivei.com.br/">neste link</a>. As APIs
          Qive utilizam o padrão REST, facilitando a integração a qualquer
          linguagem de programação. O desenvolvimento para a integração é
          responsabilidade da empresa que contratar esse serviço, então é
          importante validar com o time de TI da empresa sobre as necessidades
          de desenvolvimento para que esse serviço funcione para você. Caso você
          não tenha um time ou área de desenvolvimento, temos parceiros para te
          ajudar.
        </>
      ),
    },
    {
      title: 'Existe uma precificação diferenciada para API Qive?',
      description:
        'Sim. Além da sua contratação de recorrência da plataforma Qive, existe a precificação diferenciada para utilizar esse serviço. Caso você queira solicitar um orçamento, você pode entrar em contato conosco por e-mail, chat ou telefone.',
    },
    {
      title: 'É possível fazer um teste na API?',
      description:
        'Sim, nós disponibilizamos um teste na API utilizando o Portal do Desenvolvedor. É preciso criar uma credencial para realizar esse teste em nosso ambiente Sandbox. Esse ambiente disponibiliza toda a infraestrutura da API, como em produção, contendo seu CNPJ e notas sintéticas (com dados aleatórios, sem validade jurídica). Dessa maneira, você consegue validar todas as conexões com a API Qive e, em contato conosco, poderá tirar suas dúvidas de como tratar os dados e respostas retornadas.',
    },
    {
      title: 'Todas os XMLs e PDFs podem ser integrados via API?',
      description:
        'Atualmente, a API Qive disponibiliza XMLs e PDFs. Em XML, fica à disposição endpoints para download de NFe, CTe, CTe-OS e NFSe. Já em PDF, os endpoints para download são de DANFe, DACTe e DACTe-OS. Além disso, é possível também realizar o envio de XMLs e manifestações de NFes em lote e o envio de NFSes através do processo de OCR (Optical Character Recognization - Reconhecimento Ótico de Caracteres), realizado através de uma parceria. Todos esses endpoints podem ser conferidos nessa documentação.',
    },
    {
      title: 'É possível integrar a API em todos os sistemas (ERPs)?',
      description:
        'A API Qive utiliza padrão REST, disponibilizando a integração com diversos ERPs. Dependendo do sistema utilizado na sua empresa, será necessário parte do desenvolvimento de integração pela sua equipe de TI. Alguns dos ERPs mais conhecidos no mercado, a Qive tem parceiros que podem ajudar você e a sua equipe com essa integração.',
    },
    {
      title: 'O que torna a API da Qive mais fácil de integrar?',
      description: (
        <>
          A API Qive utiliza o padrão{' '}
          <a href="https://pt.wikipedia.org/wiki/REST">REST</a>, plenamente
          utilizado no mercado de desenvolvimento de Software, sendo possível a
          rápida integração utilizando comunicação HTTP, com poucas linhas de
          código e implementação em seu sistema. Também possibilita a integração
          utilizando-se RPA (Robotic Process Automation), visto que nosso
          webservice pode ser acessado através de uma URL aberta e a resposta
          pode ser interpretada facilmente dado os padrões que utilizamos!,
        </>
      ),
    },
    {
      title: 'Quais métodos de integração que Qive aceita?',
      description:
        'A API Qive utiliza padrão REST, tornando possível a integração utilizando qualquer linguagem de programação que permita conexões do tipo HTTP. Temos à sua disposição diversos endpoints, dentre download de XMLs e PDFs até processo de OCRização de notas de serviço, e você pode escolher o que melhor se encaixa em seu processo e seu caso de uso. Dá uma olhadinha em nossa documentação e veja o que mais se encaixa em seu uso.',
    },
    {
      title: 'A Qive faz a integração para mim?',
      description:
        'A Qive não realiza a integração. O desenvolvimento para a integração é responsabilidade da empresa após contratar o serviço. Mas não se preocupe, nosso time está a disposição para dar todo o suporte durante a integração e disponibilizamos a documentação completa da API para entender a melhor maneira de integrar com seus sistema. E caso você não tenha um time de desenvolvimento próprio, temos parceiros que podem te ajudar nesta integração.',
    },
    {
      title:
        'Quanto tempo, em média, eu preciso para ter uma integração rodando com uma API?',
      description:
        'O tempo de integração varia de acordo com a velocidade com que seu time de desenvolvimento consegue implementar esta integração. Como a API Qive é baseada no padrão REST, o mais utilizado para estas integrações no mercado, isso não deve tomar muito tempo! Claro, analisar como as APIs se encaixam em seu processo de negócios e entender com isso impacta no seu dia-a-dia é uma parte importante desta implementação. Temos pessoas preparadas para fornecer todo o suporte para te ajudar a entender essas necessidades e guiar pelo melhor caminho. Se quiser saber mais, você pode entrar em contato conosco por e-mail, chat ou telefone! =)',
    },
    {
      title: 'Qual é a diferença entre a API e o Sincroniza Notas?',
      description:
        'A API Qive possibilita integrações mais completas no processo do cliente, automatizando fluxos integrados a ERPs e sistemas utilizados pelas empresas. Já com o Sincroniza Notas, é necessária a instalação do integrador em um computador e fazer o upload ou download de notas entre este computador e o ERP e sistemas.',
    },
    {
      title: 'Quais são os ambientes de teste disponíveis?',
      description:
        'Temos disponível um ambiente de teste Sandbox, composto pelas credenciais de acesso e notas com dados sintéticos, sem validade jurídica, que reflete toda a estrutura de nossa API em produção. O funcionamento é exatamente igual e este ambiente é ideal para uma primeira implementação, para validar a integração, respostas da API, tratamento dos dados, etc. Caso você precise validar como as APIs Qive se encaixam em seu processo de negócios e exista a necessidade de utilizar notas reais, recebidas pelas suas empresas, temos também a possibilidade de se realizar os testes em um ambiente não-produtivo chamado de UAT. Nele, todos os dados são reais e um reflexo de como seria o uso em produção.',
    },
    {
      title: 'API pode ser disponibilizada para terceiros?',
      description:
        'Pode! É possível disponibilizar acesso à API Qive sem precisar passar para seu parceiro o ID e chave secreta que foram gerados para você. Através da criação de uma chave de permissão, é possível que seu parceiro integre à nossa API utilizando as credenciais de acesso dele e faça buscas, downloads e outros usos das notas disponíveis para a sua conta! Qualquer dúvida em relação a esta funcionalidade, você pode entrar em contato conosco por e-mail, chat ou telefone.',
    },
    {
      title: 'Como que funciona o gerenciamento de usuários dentro da API?',
      description:
        'Não temos a disponibilização de usuários para as APIs Qive. Ao iniciar o uso das APIs, você receberá um ID e uma chave secreta para realizar a autenticação em nosso sistema. Este ID e chave serão utilizados para autenticar todas as requisições feitas às APIs, concedendo acesso a todos os documentos disponíveis para a sua conta, a partir da contratação.',
    },
    {
      title: 'Posso enviar meus certificados via API?',
      description:
        'Até o momento não temos uma API disponível para envio de Certificados Digitais, mas esta feature está em nosso Roadmap e deve ser disponibilizada em breve! Fique de olho aqui no nosso Portal para receber notícias sobre novas versões e lançamentos.',
    },
    {
      title: 'Qual é o canal de suporte para APIs Qive?',
      description:
        'O suporte das APIs pode ser acionado através de nossos Canais de Atendimento, através de e-mail, chat ou telefone!',
    },
    {
      title: 'Existe limite de requisições?',
      description:
        'O limite de requisições para a API Qive é definido para cada cliente, de acordo com a necessidade do negócio e com o volume de notas de cada um.',
    },
  ],
};
